import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, DownloadIcon, UsersIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-24 pb-12 px-4 overflow-hidden bg-primary" data-id="element-78">
      {/* Background particles/waves placeholder */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-79">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-accent-teal via-primary to-primary" data-id="element-80"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-82">
          <div className="bg-accent-teal text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-4 inline-flex items-center" data-id="element-83">
            🧠 Basado en neurociencia y psicología
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-[56px] font-bold text-white leading-tight mb-8" data-id="element-84">
            Dejá de vivir con miedo. Tomá el control de tu ansiedad hoy.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center mb-8" data-id="element-85">
          <div className="animate-float w-full max-w-sm" data-id="element-86">
            <img src="https://cdn.magicpatterns.com/uploads/eZNq6xUDsPdm9UH1zs4tVd/heylloyd-image-1773856782580.png" alt="Pack Completo — Controla la Ansiedad y los Ataques de Pánico" className="w-full h-auto rounded-2xl shadow-[0_0_40px_rgba(212,175,55,0.2)]" data-id="element-87" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center flex flex-col items-center" data-id="element-88">
          <p className="text-accent-teal text-lg sm:text-xl font-normal max-w-[520px] mb-5 leading-relaxed" data-id="element-89">
            El único pack que combina neurociencia, psicología y protocolos de
            intervención inmediata para frenar los ataques de pánico — donde
            estés, cuando sea. Se envía por email en formato PDF.
          </p>

          <button onClick={() => {
          const w = window as any;
          if (typeof w.fbq === 'function') {
            w.fbq('track', 'InitiateCheckout', {
              content_name: 'CONTROLA LA ANSIEDAD — Pack Completo Base',
              content_ids: ['ANSIEDAD_BASE_001'],
              value: 19990,
              currency: 'ARS'
            });
          }
          setTimeout(() => {
            window.open('[TU_LINK_MERCADOPAGO_BASE]', '_blank');
          }, 300);
        }} className="w-full sm:w-auto bg-accent-gold text-primary font-bold text-lg sm:text-xl py-4 px-10 rounded-xl glow-gold transition-all duration-300 mb-5" data-id="element-90">
            🧠 QUIERO CONTROLARLO AHORA →
          </button>

          <div className="flex flex-wrap justify-center items-center gap-4 text-text-secondary text-sm" data-id="element-91">
            <div className="flex items-center" data-id="element-92">
              <LockIcon className="w-4 h-4 text-accent-teal mr-1.5" data-id="element-93" /> Pago
              Seguro SSL
            </div>
            <span className="hidden sm:inline text-accent-teal" data-id="element-94">•</span>
            <div className="flex items-center" data-id="element-95">
              <DownloadIcon className="w-4 h-4 text-accent-teal mr-1.5" data-id="element-96" />{' '}
              Acceso Inmediato
            </div>
            <span className="hidden sm:inline text-accent-teal" data-id="element-97">•</span>
            <div className="flex items-center" data-id="element-98">
              <UsersIcon className="w-4 h-4 text-accent-teal mr-1.5" data-id="element-99" /> +2.300
              personas ya lo tienen
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}